import { createAsyncThunk } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import {
  InstallmentInformerToggle,
  SubmitButtonClicked
} from '../../services/dispatchers';
import { RootState } from '../store';
import { Summary } from '../summary/types';
import { ProductEntity } from '../types';
import { ProductWithAnalytics } from '../products/types';
import { COOKIE_REGION_URL } from '../../consts';

const selectProducts = (
  state: RootState
): ProductEntity<ProductWithAnalytics> =>
  state['cartPage/products'].entities;
const selectSummary = (state: RootState): Summary | null =>
  state['cartPage/summary'].entity || null;

export const submitClick = createAsyncThunk(
  'cartPage/submitClick',
  async (_, thunkApi) => {
    const storeState = thunkApi.getState() as RootState;
    const products = selectProducts(storeState);
    const summary = selectSummary(storeState);
    const data = {
      products,
      summary
    };
    const regionUrl = Cookies.get(COOKIE_REGION_URL) || '/';
    const url = `${regionUrl}personal/order/make`;

    SubmitButtonClicked.dispatch(data);

    if (window._eaptekaIsHostMF) {
      window.history.pushState({}, '', url);
    } else {
      window.location.assign(url);
    }
  }
);

export const installmentInformerClick = createAsyncThunk(
  'cartPage/installmentInformerClick',
  async (_, thunkApi) => {
    const storeState = thunkApi.getState() as RootState;
    const products = selectProducts(storeState);
    const summary = selectSummary(storeState);
    const isCartInstallmentAvailable =
      summary?.isCartInstallmentAvailable || false;

    const data = {
      products,
      summary,
      isCartInstallmentAvailable
    };

    InstallmentInformerToggle.dispatch(data);
  }
);
